import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getProducts } from '../api/apiendpoint';
import { Form, FormControl, InputGroup } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';

const NavbarSearch = () => {
  const [query, setQuery] = useState('');
  const [products, setProducts] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      const data = await getProducts();
      setProducts(data);
    };
    fetchProducts();
  }, []);

  const handleSearch = (e) => {
    setQuery(e.target.value);
    setShowDropdown(true);
  };

  const filtered = query.trim()
    ? products.filter(
        (p) =>
          p.product_name &&
          p.product_name.toLowerCase().includes(query.toLowerCase())
      )
    : [];

  const handleSelect = (product) => {
    setQuery('');
    setShowDropdown(false);
    navigate(`/product/${product.id}`); // ✅ navigate by ID
  };

  return (
    <div className="position-relative w-100">
      <Form className="w-100">
        <InputGroup className="mx-auto" style={{ maxWidth: '500px' }}>
          <FormControl
            type="search"
            placeholder="Search products..."
            aria-label="Search"
            className="border-dark"
            value={query}
            onChange={handleSearch}
            onFocus={() => setShowDropdown(true)}
            onBlur={() => setTimeout(() => setShowDropdown(false), 150)}
          />
          <InputGroup.Text className="bg-white border-start-0">
            <FaSearch className="text-success" />
          </InputGroup.Text>
        </InputGroup>
      </Form>

      {showDropdown && filtered.length > 0 && (
        <div
          className="position-absolute bg-white border shadow-sm mt-1 w-100"
          style={{ maxWidth: '500px', zIndex: 1050 }}
        >
          {filtered.slice(0, 5).map((product) => (
            <div
              key={product.id}
              className="d-flex align-items-center gap-2 px-3 py-2 border-bottom"
              style={{ cursor: 'pointer' }}
              onMouseDown={() => handleSelect(product)}
            >
              <img
                src={product.images[0]} // or product.images[0].image if it's an object
                alt={product.product_name}
                style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: '4px' }}
              />
              <span>{product.product_name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NavbarSearch;
